import { UIText2 } from '@cian/ui-kit';

import { FC } from 'react';

import styles from './MapNotifications.css';

type MapNotificationsProps = {
  notificationText: string;
};

export const MapNotifications: FC<MapNotificationsProps> = props => {
  const { notificationText } = props;

  return (
    <div className={styles['notifications-container']}>
      <div className={styles['notifications']}>
        <UIText2 color="white_100">{notificationText}</UIText2>
      </div>
    </div>
  );
};
